'use es6';

import { toCamelCase } from 'ContentEditorUI/utils/helpers';
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { updateHighlightedWidgetId } from 'ContentEditorUI/redux/actions/inpageActions';
import { setScrollTo } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { createUpdateFocusedItem } from 'ContentEditorUI/redux/actions/baseFocusActions';
import { openPanel } from 'ContentEditorUI/redux/actions/panelActions';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { getCurrentTab } from '../selectors/baymaxNavSelectors';
import { clearInpageUIState } from 'ContentEditorUI/redux/actions/inpageActions';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
const BLOG_SETTINGS_REDUX_FIELDS = ['metaDescription', 'name', 'blogAuthorId', 'slug', 'featuredImage', 'language', 'tags'];
const postFocusLogic = (focusedItem, dispatch, state, options) => {
  const camelCaseFocusedItem = toCamelCase(focusedItem);
  const currentTab = getCurrentTab(state);
  const isUngatedForPatagonia = getIsUngatedForPatagonia(state);
  if (options.moduleId) {
    if (currentTab.id !== 'content') {
      dispatch(clearInpageUIState());
    }
    if (focusedItem === 'contentPane') {
      dispatch(routeToPage('content'));
      dispatch(openPanel(SIDEBAR_PANELS.widgetList, {
        scrollToModuleInList: options.moduleId
      }));
      dispatch(updateHighlightedWidgetId(options.moduleId));
    } else {
      dispatch(routeToPage('content'));
      dispatch(updateHighlightedWidgetId(options.moduleId));
    }
  } else if (focusedItem === 'publishDate') {
    if (currentTab.id !== 'publishing') {
      dispatch(clearInpageUIState());
    }
    dispatch(routeToPage('publishing'));
  } else if (BLOG_SETTINGS_REDUX_FIELDS.includes(camelCaseFocusedItem)) {
    if (currentTab.id !== 'settings' && !isUngatedForPatagonia) {
      dispatch(clearInpageUIState());
    }
    if (!isUngatedForPatagonia) {
      dispatch(routeToPage('settings'));
    } else {
      dispatch(openModal(MODAL_TYPES.SETTINGS_MODAL));
    }
    const fieldToScrollTo = !isUngatedForPatagonia ? camelCaseFocusedItem : options.settingsModalQuery;
    dispatch(setScrollTo(fieldToScrollTo));
  }
};
export const updateFocusedItem = createUpdateFocusedItem(postFocusLogic);